import PropTypes from 'prop-types'
import { mensajeVigenciaAviso } from '../../constants/publicaciones.js'
import { formatearFecha } from '../../helpers/dateValidation'
import InputLabel from '../ui/InputLabel'
import styles from './FechaPublicacion.module.css'

const FORMATO_INPUT_DATE = 'YYYY-MM-DD'

const FechaPublicacion = ({
  publicacion,
  onChange,
  vieneDeAdministrar,
  vigenciaPorAviso,
  fechaVencimientoAviso
}) => {
  const fechaDesdeFormateada = formatearFecha(publicacion.desde, FORMATO_INPUT_DATE)
  const fechaHastaFormateada = formatearFecha(publicacion.hasta, FORMATO_INPUT_DATE)
  const disabledInputFecha = Boolean(publicacion.idListaVenta) || vigenciaPorAviso

  const fechaVencimiento = formatearFecha(fechaVencimientoAviso, 'DD/MM/YYYY [a las] HH:mm')

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Indicá desde qué fecha querés que tu producto esté disponible al público.
        </p>
      )}
      <div className={styles.filaInputs}>
        <InputLabel
          type="date"
          name="desde"
          value={fechaDesdeFormateada}
          classNameInput={styles.inputFecha}
          onChange={onChange}
          label="Fecha desde: "
          error="Completar Fecha desde"
          disabled={disabledInputFecha}
        />
        <InputLabel
          type="date"
          name="hasta"
          value={fechaHastaFormateada}
          classNameInput={styles.inputFecha}
          onChange={onChange}
          label="Fecha hasta: "
          error="Completar Fecha hasta"
          disabled={disabledInputFecha}
        />
        {vieneDeAdministrar && <div />}
      </div>
      {vigenciaPorAviso ? (
        <p className="warningMessage">{mensajeVigenciaAviso(fechaVencimiento)}</p>
      ) : (
        <p className="warningMessage mt-2">
          En caso de seleccionar una lista de venta se utilizará esa vigencia.
        </p>
      )}
    </>
  )
}

FechaPublicacion.propTypes = {
  publicacion: PropTypes.shape({
    desde: PropTypes.string,
    hasta: PropTypes.string,
    idListaVenta: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool,
  vigenciaPorAviso: PropTypes.bool,
  fechaVencimientoAviso: PropTypes.string
}

export default FechaPublicacion
